<template>
  <v-card class="page-card report-panel">
    <v-card-title class="report-panel-title">Reportes de agroquimicos</v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col v-if="can('agrochemicals.reports.costs.export')" cols="12" md="4">
          <v-btn
            :loading="!downloadCostReportEnable"
            :disabled="!downloadCostReportEnable"
            color="primary"
            class="text-white report-button"
            block
            @click="downloadCostReport()">
            <v-icon start>cloud_download</v-icon>
            Reporte de Costos
          </v-btn>
        </v-col>
        <v-col v-if="can('agrochemicals.reports.stock.export')" cols="12" md="4">
          <v-btn
            :loading="!downloadStockReportEnable"
            :disabled="!downloadStockReportEnable"
            color="primary"
            class="text-white report-button"
            block
            @click="downloadStockReport()">
            <v-icon start>cloud_download</v-icon>
            Stock
          </v-btn>
        </v-col>
        <v-col v-if="can('agrochemicals.reports.withdrawals.export')" cols="12" md="4">
          <v-btn
            :loading="!downloadWithdrawReportEnable"
            :disabled="!downloadWithdrawReportEnable"
            color="primary"
            class="text-white report-button"
            block
            @click="downloadWithdrawReport()">
            <v-icon start>cloud_download</v-icon>
            Reporte de Retiros
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import axios from '../../services/common/CommonConfigRestService'

export default {
  name: 'ExportAgrochemicalForm',
  data: () => ({
    downloadCostReportEnable: true,
    downloadStockReportEnable: true,
    downloadWithdrawReportEnable: true
  }),

  methods: {
    can (permission) { return this.$store.getters['authModule/hasPermission'](permission) },
    async downloadCostReport () {
      this.downloadCostReportEnable = false
      await axios({
        url: '/agrochemical/cost-report',
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Reporte de Costos.xlsx')
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        console.log(error)
      })
      this.downloadCostReportEnable = true
    },

    async downloadStockReport () {
      this.downloadStockReportEnable = false
      await axios({
        url: '/agrochemical/stock-report',
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Stock de Agroquimicos.xlsx')
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        console.log(error)
      })
      this.downloadStockReportEnable = true
    },

    async downloadWithdrawReport () {
      this.downloadWithdrawReportEnable = false
      await axios({
        url: '/agrochemical/withdraw-report',
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Reporte de retiros.xlsx')
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        console.log(error)
      })
      this.downloadWithdrawReportEnable = true
    }
  }

}
</script>
